// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/css/relatorio.css
// module id = 45
// module chunks = 1